
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { LinkGrid } from '../../app/components';
import { figmaCommunityFileLinks, figmaPluginLinks } from '../../__configuration__/design';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    {
      /* KEYWORDS: design resources */
    }
    <h1>{`Designer Resources`}</h1>
    <p>{`We provide the following easy-to-use Figma community resources. They are also listed publicly under the Figma community profile name `}<a parentName="p" {...{
        "href": "https://figma.com/@eaton_community"
      }}>{`@eaton_comunity`}</a>{`.`}</p>
    <h2>{`Community Files`}</h2>
    <p>{`The Brightlayer UI community files can be duplicated into your own draft space, and you can play around with our components and patterns however you like or use them to build up your own project designs.`}</p>
    <LinkGrid links={figmaCommunityFileLinks} style={{
      marginTop: 16
    }} mdxType="LinkGrid" />
    <h2>{`Plugin`}</h2>
    <p>{`Helpful utility tools that speed up your design.`}</p>
    <LinkGrid links={figmaPluginLinks} style={{
      marginTop: 16
    }} mdxType="LinkGrid" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;